/* eslint-disable max-len */
export default {
    security: [
        {
            id: 512,
            title: "Home VPN Security",
            description: "...",
            time: "3 mins",
            thumbnail:
                "https://posture-ninjio.s3.us-west-2.amazonaws.com/Security/S05E12/512_lockscreen_blank.jpg",
            video:
                "https://posture-ninjio.s3.us-west-2.amazonaws.com/Security/S05E12/3-NINJIO-S5E12-Subs-NoQuiz.mp4",
        },
        {
            id: 609,
            title: "Passphrase Protection",
            description: "...",
            time: "4 mins",
            thumbnail:
                "https://posture-ninjio.s3.us-west-2.amazonaws.com/Security/S06E09/609_lockscreen_blank.jpg",
            video:
                "https://posture-ninjio.s3.us-west-2.amazonaws.com/Security/S06E09/3-NINJIO-S6E09-Subs-NoQuiz.mp4",
        },
        {
            id: 706,
            title: "Insider Threats",
            description: "...",
            time: "5 mins",
            thumbnail:
                "https://posture-ninjio.s3.us-west-2.amazonaws.com/Security/S07E06/706_lockscreen.jpg",
            video:
                "https://posture-ninjio.s3.us-west-2.amazonaws.com/Security/S07E06/3-NINJIO-S7E06-Subs-NoQuiz.mp4",
        },
        {
            id: 711,
            title: "Security Updates",
            description: "...",
            time: "5 mins.",
            thumbnail:
                "https://posture-ninjio.s3.us-west-2.amazonaws.com/Security/S07E11/711_lockscreen_blank.jpg",
            video:
                "https://posture-ninjio.s3.us-west-2.amazonaws.com/Security/S07E11/3-NINJIO-S7E11-Subs-NoQuiz.mp4",
        },
        {
            id: 808,
            title: "Artificial Intelligence Data Privacy",
            description: "...",
            time: "5 mins.",
            thumbnail:
                "https://posture-ninjio.s3.us-west-2.amazonaws.com/Security/S08E08/808_lockscreen_blank.jpg",
            video:
                "https://posture-ninjio.s3.us-west-2.amazonaws.com/Security/S08E08/3-NINJIO-S8E08-Subs-NoQuiz.mp4",
        },
        {
            id: 904,
            title: "Multi-Factor Authentication Bypass",
            description: "...",
            time: "5 mins.",
            thumbnail:
                "https://posture-ninjio.s3.us-west-2.amazonaws.com/Security/S09E04/904_lockscreen_blank.jpg",
            video:
                "https://posture-ninjio.s3.us-west-2.amazonaws.com/Security/S09E04/3-NINJIO-S9E04-Subs-NoQuiz.mp4",
        },
  ],
  hipaa: [    
    {
    id: 502,
    title: "Episode 1 | An Avoidable Accident",
    description: "...",
    time: "5 mins.",
    thumbnail:
      "https://posture-ninjio.s3-us-west-2.amazonaws.com/HIPAA/Episode+1/An+Avoidable+Accident.png",
    video:
      "https://posture-ninjio.s3-us-west-2.amazonaws.com/HIPAA/Episode+1/Episode+1+An+Avoidable+Accident.mp4"
  },
  {
    id: 504,
    title: "Episode 2 | Placing the Blame",
    description: "...",
    time: "4 mins.",
    thumbnail:
      "https://posture-ninjio.s3-us-west-2.amazonaws.com/HIPAA/Episode+2/Placing+the+Blame.png",
    video:
      "https://posture-ninjio.s3-us-west-2.amazonaws.com/HIPAA/Episode+2/Episode+2+Placing+the+Blame.mp4"
  },
  {
    id: 510,
    title: "Episode 3 | Time for a Change",
    description: "...",
    time: "4 mins.",
    thumbnail:
      "https://posture-ninjio.s3-us-west-2.amazonaws.com/HIPAA/Episode+3/Time+for+a+Change.png",
    video:
      "https://posture-ninjio.s3-us-west-2.amazonaws.com/HIPAA/Episode+3/Episode+3+Time+for+a+Change.mp4"
  },
  ],
  currentMonthsVideo: [
    {
      id: 1110,
      title: "S11E10 | NINJIO",
      description: "...",
      time: "5 mins.",
      thumbnail:
        "https://posture-ninjio.s3.us-west-2.amazonaws.com/season_11/episode_10/1110_lockscreen_blank.png",
      video:
        "https://posture-ninjio.s3.us-west-2.amazonaws.com/season_11/episode_10/3-NINJIO-S11E10-Subs-NoQuiz.mp4"
    }
  ],
  pci: [
    {
      id: "101",
      title: "Episode 1 | The Disinterested CEO",
      description: "",
      time: "4 mins.",
      thumbnail: "https://posture-ninjio.s3-us-west-2.amazonaws.com/PCI/episode_1/PCI+Episode+1+Thumbnail.png",
      video: "https://posture-ninjio.s3-us-west-2.amazonaws.com/PCI/episode_1/3-PCI_EP1_Final_SubtitleNoQuiz.mp4"
    },
    {
      id: "102",
      title: "Episode 2 | Just Scraping By",
      description: "",
      time: "4 mins.",
      thumbnail: "https://posture-ninjio.s3-us-west-2.amazonaws.com/PCI/episode_2/PCI+Episode+2+Thumbnail.png",
      video: "https://posture-ninjio.s3-us-west-2.amazonaws.com/PCI/episode_2/3-PCI_EP2_Final_SubtitleNoQuiz.mp4"
    },
    {
      id: "103",
      title: "Episode 3 | Life's A Breach",
      description: "",
      time: "4 mins.",
      thumbnail: "https://posture-ninjio.s3-us-west-2.amazonaws.com/PCI/episode_3/PCI+Episode+3+Thumbnail.png",
      video: "https://posture-ninjio.s3-us-west-2.amazonaws.com/PCI/episode_3/3-PCI_EP3_Final_SubtitleNoQuiz.mp4"
    },
    {
      id: "104",
      title: "Episode 4 | Payment Card Predicament",
      description: "",
      time: "6 mins.",
      thumbnail: "https://posture-ninjio.s3-us-west-2.amazonaws.com/PCI/episode_4/PCI+Episode+4+Thumbnail.png",
      video: "https://posture-ninjio.s3-us-west-2.amazonaws.com/PCI/episode_4/3_PCI_4_NoQuiz_Sub.mp4"
    }
  ],
  incidentresponse : [
    {
      id: "1",
      title: "Incident Response Training - Module 1",
      description: "",
      time: "3 mins.",
      thumbnail: "https://posture-ninjio.s3.us-west-2.amazonaws.com/Incident+Response+(IR)/Module+1/Incident+Response+Training+Module+1.png",
      video: "https://posture-ninjio.s3.us-west-2.amazonaws.com/Incident+Response+(IR)/Module+1/Incident+Response+Training+Module+1.mp4"
    },
    {
      id: "2",
      title: "Incident Response Training - Module 2",
      description: "",
      time: "5 mins.",
      thumbnail: "https://posture-ninjio.s3.us-west-2.amazonaws.com/Incident+Response+(IR)/Module+2/Incident+Response+Training+Module+2+(Updated).png",
      video: "https://posture-ninjio.s3.us-west-2.amazonaws.com/Incident+Response+(IR)/Module+2/Incident+Response+Training+Module+2.mp4"
    },
    {
      id: "3",
      title: "Incident Response Training - Module 3",
      description: "",
      time: "5 mins.",
      thumbnail: "https://posture-ninjio.s3.us-west-2.amazonaws.com/Incident+Response+(IR)/Module+3/Incident+Response+Training+Module+3.png",
      video: "https://posture-ninjio.s3.us-west-2.amazonaws.com/Incident+Response+(IR)/Module+3/Incident+Response+Training+Module+3.mp4"
    },
    {
      id: "4",
      title: "Incident Response Training - Module 4",
      description: "",
      time: "3 mins.",
      thumbnail: "https://posture-ninjio.s3.us-west-2.amazonaws.com/Incident+Response+(IR)/Module+4/Incident+Response+Training+Module+4.png",
      video: "https://posture-ninjio.s3.us-west-2.amazonaws.com/Incident+Response+(IR)/Module+4/Incident+Response+Training+Module+4.mp4"
    },
    {
      id: "5",
      title: "Incident Response Training - Module 5",
      description: "",
      time: "1 min.",
      thumbnail: "https://posture-ninjio.s3.us-west-2.amazonaws.com/Incident+Response+(IR)/Module+5/Incident+Response+Training+Module+5.png",
      video: "https://posture-ninjio.s3.us-west-2.amazonaws.com/Incident+Response+(IR)/Module+5/Incident+Response+Training+Module+5.mp4"
    }      
  ]
};




// WEBPACK FOOTER //
// ./src/components/training/components/catalog_list.js